import React from "react";
function ListPagination(props) {
  let pageButtons = [];
  if (!props.pagination["pages"]) return null;

  for (let p = 1; p <= props.pagination.pages; p++) {
    pageButtons.push(
      <span
        key={p}
        onClick={() => change(p)}
        className={`btn btn-circle btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1 ${
          props.page === p ? "active" : ""
        }`}
      >
        {p}
      </span>
    );
  }
  function change(pageNumber) {
    if (pageNumber < 1) pageNumber = 1;
    if (pageNumber > props.pagination.pages)
      pageNumber = props.pagination.pages;
    props.changeFn(pageNumber);
  }
  let limitVariants = [5, 10, 20, 30, 50, 100, 150];

  const showPagesCount = 2;

  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap   mt-5 pt-2">
      <div className="d-flex flex-wrap py-2 mr-3">
        <span
          onClick={() => change(1)}
          className="btn btn-circle btn-icon btn-sm btn-light mr-2 my-1"
        >
          <i className="fa fa-angle-double-left icon-md"></i>
        </span>
        <span
          onClick={() => change(props.page - 1)}
          className="btn btn-circle btn-icon btn-sm btn-light mr-2 my-1"
        >
          <i className="fa fa-angle-left icon-md"></i>
        </span>

        {props.page > showPagesCount ? (
          <span className="d-flex align-items-center ml-4">...</span>
        ) : null}

        {pageButtons.map((el, p) => {
          if (
            props.page - p > showPagesCount ||
            p - props.page > showPagesCount - 1
          )
            return null;
          return el;
        })}

        {props.pagination.pages - props.page > showPagesCount ? (
          <span className="d-flex align-items-center mr-4">...</span>
        ) : null}

        <span
          onClick={() => change(props.page + 1)}
          className="btn btn-circle btn-icon btn-sm btn-light mr-2 my-1"
        >
          <i className="fa fa-angle-right icon-md"></i>
        </span>
        <span
          onClick={() => change(props.pagination.pages)}
          className="btn btn-circle btn-icon btn-sm btn-light mr-2 my-1"
        >
          <i className="fa fa-angle-double-right icon-md"></i>
        </span>
      </div>
      <div className="d-flex align-items-center justify-content-between py-3">
        <div className="text-muted text-nowrap font-size-xs mr-2">
          {props.pagination.total} / {props.pagination.pages}
        </div>
        <select
          value={props.pagination.limit}
          onChange={(e) => {
            change(1);
            props.limitChangeFn(e.target.value);
          }}
          className="form-control   text-dark-50 font-weight-bold mr-4 border-0 bg-light"
        >
          {limitVariants.map((l) => (
            <option key={l} value={l}>
              {l}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
export default ListPagination;
